import { render } from "./Sider.vue?vue&type=template&id=41f10115&scoped=true"
import script from "./Sider.vue?vue&type=script&lang=js"
export * from "./Sider.vue?vue&type=script&lang=js"

import "./Sider.vue?vue&type=style&index=0&id=41f10115&lang=scss&scoped=true"

import exportComponent from "/builds/springup/oa-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41f10115"]])

export default __exports__